/* eslint-disable import/no-named-as-default */
import { all, AllEffect, ForkEffect } from 'redux-saga/effects';

import watchAuth from './auth';
import watchBranding from './branding';
import watchEmailVerification from './email-verification';
import watchFhqGeneralSettings from './fhq-general-settings';
import watchFhqHelpContacts from './fhq-help-contacts';
import watchFhqInvitationSettings from './fhq-invitation-settings';
import watchFhqIpWhitelistRecords from './fhq-ip-whitelist-records';
import watchFhqs from './fhqs';
import watchFhqTemplates from './fhq-templates';
import watchFhqUsers from './fhq-users';
import watchGlossaryData from './glossary';
import watchNotificationRules from './notification-rules';
import watchOrganizations from './organizations';
import watchPermissions from './permissions';
import watchProfile from './profile';
import watchRecoveryBin from './recovery-bin';
import watchRiskRecord from './risk-record';
import watchSecuritySetting from './security-setting';
import watchSites from './sites';
import watchTabsAccess from './tabs-access';
import watchUserGroups from './user-groups';
import watchUsers from './users';
import watchHealthcheck from './healthcheck';

export type SagaGenerator = Generator<AllEffect<Generator<ForkEffect<unknown>, void, unknown>>, void, unknown>;
export type RootSagaGenerator = Generator<AllEffect<SagaGenerator>, void, unknown>;

export default function* rootSaga(): RootSagaGenerator {
  yield all([
    watchAuth(),
    watchBranding(),
    watchEmailVerification(),
    watchFhqGeneralSettings(),
    watchFhqHelpContacts(),
    watchFhqInvitationSettings(),
    watchFhqIpWhitelistRecords(),
    watchFhqs(),
    watchFhqTemplates(),
    watchFhqUsers(),
    watchGlossaryData(),
    watchNotificationRules(),
    watchOrganizations(),
    watchPermissions(),
    watchProfile(),
    watchRecoveryBin(),
    watchRiskRecord(),
    watchSecuritySetting(),
    watchSites(),
    watchTabsAccess(),
    watchUserGroups(),
    watchUsers(),
    watchHealthcheck(),
  ]);
}
